import { X } from 'lucide-react';

const NotificationToastCloseButton = ({ closeToast, ariaLabel, theme = 'light' }) => {
  const handleClose = (event) => {
    // The toast itself remains click-to-dismiss. Keep this control's activation
    // from bubbling into that handler so closeToast owns one dismissal event.
    event.stopPropagation();
    closeToast?.(true);
  };

  return (
    <button
      type="button"
      className={`Toastify__close-button Toastify__close-button--${theme} shuttle-notification-close-button`}
      aria-label={ariaLabel}
      onClick={handleClose}
    >
      <X aria-hidden="true" focusable="false" />
    </button>
  );
};

export default NotificationToastCloseButton;
